
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useEffect } from "react";
import { FaUser } from "react-icons/fa";
import Head from "next/head";
import Image from "next/image";
import useTranslation from "next-translate/useTranslation";
import { useSiteData } from "../../redux/siteData";
// import { hasBadWord } from "../../util/badWords";
// import { loginGuest } from "../../ducks/guest";
// import { setIframeMode } from "../../ducks/siteData";
// import VideoAd from "../../components/VideoAd";
// import Script from "next/script";
// import { useRouter } from "next/router";
import { websocket } from "../../services/websocket";
import { signInStatus } from "../../redux/signIn";
// const blockList = ["webnode.com.br", "officegamespot.com"];
// function isBlocked() {
//   const parentUrl =
//     window.location != window.parent.location
//       ? document.referrer
//       : document.location.href;
//   for (let i = 0; i < blockList.length; i++) {
//     if (parentUrl.indexOf(blockList[i]) >= 0) {
//       return true;
//     }
//   }
//   return false;
// }
export default function Iframe() {
    const { playersOnline } = useSiteData();
    // const [username, setUsername] = useState("");
    // const [error, setError] = useState(false);
    // const [adSize, setAdSize] = useState(null);
    // const [playVideo, setPlayVideo] = useState(false);
    // const inputRef = useRef(null);
    // const router = useRouter();
    const { t } = useTranslation("common");
    useEffect(() => {
        if (!websocket) {
            signInStatus();
        }
    }, []);
    // useEffect(() => {
    //   // inputRef.current.focus();
    //   setAdSize({ w: window.innerWidth, h: window.innerHeight });
    // }, []);
    function handleKeyDown(e) {
        if (e.key === "Enter") {
            doSubmit();
        }
    }
    function doSubmit() {
        // const name = username.trim();
        // if (name === "" || !name || hasBadWord(name) || name.length > 15) {
        //   setError(true);
        // } else {
        //   setIframeMode();
        //   setError(false);
        //   loginGuest(name);
        //   if (isBlocked()) {
        window.open(`https://www.chesshotel.com`, "_blank").focus();
        //   } else {
        //     setPlayVideo(true);
        //   }
        // }
    }
    return (<div style={{
            backgroundImage: "url(/images/tile.png)",
            backgroundRepeat: "repeat",
        }} className="flex items-center justify-center w-full h-screen bg-altblue-600">
      {/* <Script
          src="https://imasdk.googleapis.com/js/sdkloader/ima3.js"
          strategy="lazyOnload"
        /> */}
      <Head>
        <title>{"Chess Hotel | " + t("Play chess online")}</title>
        <meta name="description" content={t("description")}/>
        <meta name="keywords" content={t("keywords")}/>
      </Head>
      {/* {playVideo && (
          <VideoAd
            adSize={adSize}
            locale={router.locale}
            onAdEnded={() => {
              setPlayVideo(false);
              router.push("/iframe/lobby");
            }}
          />
        )} */}
      <div style={{
            backgroundImage: "url(/images/jumbotron-830.png)",
            backgroundPosition: "center bottom",
            backgroundRepeat: "no-repeat",
        }} className="flex flex-col items-center justify-center w-full h-full">
        <div className="flex flex-col items-center">
          <Image width="150" height="67" alt="chesshotel" src="/images/logo-white2.png"/>
          <div className="flex flex-col items-center mt-5">
            <div className="flex flex-col items-center justify-between w-full mt-5 text-white">
              <div className="flex h-5 mb-1.5">
                <FaUser />
                <div style={{ marginLeft: "5px", marginTop: "-2px" }}>
                  {playersOnline}
                </div>
              </div>
              <div className="text-xs text-nowrap">{t("PLAYERS ONLINE")}</div>
            </div>
            <div className="flex flex-col items-center mt-4">
              {/* <input
          onFocus={() => setError(false)}
          className={`m-5 bg-altblue-500 w-52 h-11 rounded-md text-white p-2
      ${error ? "border border-red-500" : ""}
    `}
          type="text"
          onChange={(e) => setUsername(e.target.value)}
          onKeyDown={handleKeyDown}
          name="username"
          placeholder={t("Username")}
        /> */}
              <button className="btn btn-xs btn-base w-52 h-11 btn-red" onClick={() => doSubmit()}>
                {t("Play")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>);
}

    async function __Next_Translate__getStaticProps__19e5a54c50d__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/iframe/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19e5a54c50d__ as getStaticProps }
  